const dataArrayHandle = (data: any[] = []) => {
  if (data && data.length) return data;
  return [];
};
export default dataArrayHandle;
